import { useEffect, useRef } from 'react'
import { useAtomValue } from 'jotai'
import { useMinutesSecondsTimer } from 'hooks/useMinutesSecondsTimer'
import { quoteAtom } from '../atoms/atoms'

export const useCountdownHighlight = (onExpiry: () => void) => {
  const quote = useAtomValue(quoteAtom)
  const lastExpiryDateRef = useRef<number | undefined>()

  const totalExpiry = Math.round(
    (new Date(quote?.acceptanceExpiryDate).getTime() - new Date().getTime()) / 1000
  )

  const { formattedTime, timeLeft, resetTimer } = useMinutesSecondsTimer(
    0,
    totalExpiry,
    true,
    onExpiry
  )

  useEffect(() => {
    if (quote?.acceptanceExpiryDate && quote.acceptanceExpiryDate !== lastExpiryDateRef.current) {
      lastExpiryDateRef.current = quote.acceptanceExpiryDate
      resetTimer()
    }
  }, [quote?.acceptanceExpiryDate, resetTimer])

  useEffect(() => {
    if (timeLeft) return

    resetTimer()
  }, [timeLeft, resetTimer])

  return {
    formattedTime,
    timeLeft,
    resetTimer,
  }
}
